const FrameStyle = {
  // background: 'rgba(200,200,200,0.2',
  padding: '.5rem .5rem',
  margin: '1rem 0 0',
  borderRadius: '1rem',
};

export default FrameStyle;
